@if (isEditingName()) {
    <!-- Modo de edição: apenas input -->
    <div class="session-item session-item-editing">
        <input 
            type="text"
            class="session-name-input"
            [value]="editingName()"
            (input)="editingName.set($any($event.target).value)"
            (blur)="saveName()"
            (keydown.enter)="saveName()"
            (keydown.escape)="cancelEdit()"
            #nameInput>
    </div>
}
@else {
    <div class="step-row" [class.with-rail]="showRail()">

        <!-- Trilha de etapas (modo checklist): nó numerado ligado ao vizinho pela
             linha. Concluída = verde com tique; a próxima pendente ganha halo azul.
             O nó É o check: clicar marca/desmarca a seção. -->
        @if (showRail()) {
            <div class="step-rail" (click)="$event.stopPropagation()">
                <span class="rail-line" [class.blank]="step().isFirst" [class.on]="step().prevDone"></span>
                <button
                    type="button"
                    class="step-node"
                    [class.done]="isDone()"
                    [class.current]="isNextStep()"
                    [class.default-disabled]="!canComplete()"
                    [attr.aria-pressed]="isDone()"
                    [raTooltip]="{ text: stepTooltip(), position: 'right' }"
                    (click)="toggleStep()">
                    @if (isDone()) {
                        <ra-icon icon="tick" varColor="currentColor" [size]="14" />
                    }
                    @else {
                        {{ step().num }}
                    }
                </button>
                <span class="rail-line" [class.blank]="step().isLast" [class.on]="isDone()"></span>
            </div>
        }

        <div class="step-main">
            <div
                class="session-item"
                [class.default-disabled]="disabled()"
                [class.collapsed]="collapsed()"
                [raTooltip]="{ text: collapsed() ? section().name : '', position: 'right' }"
                [class.active]="section()?._id === editDataService.getCurrentSessionId()"
                [class.session-done-card]="isChecklistMode() && isDone()"
                [class.session-item-focused]="section().focused"
                [style.--session-focus-color]="section().focused ? getFocusedUserColor() : null"
                [style.--session-accent]="'var(--' + accentToken() + ')'"
                [style.--session-accent-light]="'var(--' + accentToken() + 'Light)'"
                (click)="openSection()">

                <!-- Left side -->
                <div class="container-left">

                    <!-- Drag Handle (na trilha vai para a direita, visível no hover) -->
                    @if (!showRail()) {
                        <div
                            cdkDragHandle
                            class="drag-handle" 
                            [class.default-disabled]="editService.loading()"
                            [raEditTooltip]="{ text: ('document.edit.sessionCard.dragToReorder' | translate), position: 'bottom' }"
                            (click)="$event.stopPropagation()">
                            <ra-icon icon="menu" varColor="currentColor" [size]="16" />
                        </div>
                    }

                    <!-- Avatar do tipo de mídia: sempre visível — mesmo layout com e
                         sem modo checklist -->
                    <ra-media-type-avatar [session]="section()" [size]="collapsed() ? 22 : 25" />

                    <!-- Infos -->
                    <div class="container-infos">
                        
                        <!-- Title -->
                        <p
                            class="ra-label-xs ra-overflow-ellipsis"
                            [class.session-done]="isChecklistMode() && isDone() && !showRail()"
                            [raEditTooltip]="{ text: section().name, position: 'right' }">
                            {{ section().name }}
                        </p>

                        @if (showRail() && isDone()) {
                            <!-- Etapa concluída: quem e quando, no lugar da contagem -->
                            <p class="ra-label-xs session-done-by ra-overflow-ellipsis">
                                {{ 'document.edit.checklist.completedBy' | translate:{ name: section().checklist?.doneByName || '' } }}
                                @if (section().checklist?.doneAt) {
                                    <span class="done-date">· {{ section().checklist.doneAt | date:doneAtFormat() }}</span>
                                }
                            </p>
                        }
                        @else {
                            <!-- Contagem de itens (mesmo layout com e sem checklist). O
                                 tamanho em KB saiu do card: é informação de sistema. -->
                            <p class="ra-label-xs content-tertiary session-meta">
                                {{ section().items?.length || 0 }} {{ (section().items?.length === 1 ? 'item' : 'itens') }}
                            </p>

                            <!-- Modo checklist sem trilha (ex.: assinatura): quando concluída,
                                 mostra quem concluiu. -->
                            @if (isChecklistMode() && !collapsed() && isDone()) {
                                <p class="ra-label-xs session-done-by">
                                    <ra-icon icon="tick" varColor="accentGreen" [size]="13" />
                                    {{ 'document.edit.checklist.completedBy' | translate:{ name: section().checklist?.doneByName || '' } }}
                                    @if (section().checklist?.doneAt) {
                                        <span class="done-date">· {{ section().checklist.doneAt | date:'shortDate' }}</span>
                                    }
                                </p>
                            }
                        }
                    </div>
                </div>

                <!-- Right side: âncora do CDK overlay (sempre presente) para posicionar o menu à direita sem ser cortado pelo scroll -->
                <div
                    class="session-item-actions-wrap"
                    cdkOverlayOrigin
                    #sessionOptionsOrigin="cdkOverlayOrigin">
                    @if (loading()) {
                        <ra-loading [size]="'small'" />
                    }
                    @else {
                        <div class="container-actions">

                            <!-- Próxima etapa pendente -->
                            @if (showRail() && isNextStep()) {
                                <span class="next-chip">{{ 'document.edit.checklist.nextChip' | translate }}</span>
                            }

                            <!-- Warning de imagens não carregadas -->
                            @if (section().hasMediaNotLoaded) {
                                <ra-icon
                                    icon="warning"
                                    varColor="alertWarning"
                                    [size]="18"
                                    [raTooltip]="{ text: ('document.edit.sessionCard.mediaNotLoaded' | translate) }" />
                            }

                            <!-- Se tiver em foco, mostrar o ícone de usuário (mesma cor do header) -->
                            @if (section().focused) {
                                <ra-user-avatar 
                                    [focusedUser]="section().focused" 
                                    [avatarSize]="25" 
                                    [avatarColor]="getFocusedUserColor()" 
                                    [raTooltip]="{ text: sessionFocusTooltip() }"
                                />
                            }
                
                            <!-- Ver descrição (só quando já existe uma preenchida) -->
                            @if (isChecklistMode() && !collapsed() && hasDescription()) {
                                <ra-icon
                                    icon="info-circle"
                                    varColor="contentSecondary"
                                    [size]="18"
                                    [raEditTooltip]="{ text: ('document.edit.sessionCard.viewDescription' | translate), position: 'top' }"
                                    (click)="$event.stopPropagation(); openDescription()" />
                            }

                            <!-- Drag Handle na trilha: à direita, aparece no hover -->
                            @if (showRail()) {
                                <div
                                    cdkDragHandle
                                    class="drag-handle drag-handle-right"
                                    [class.default-disabled]="editService.loading()"
                                    [raEditTooltip]="{ text: ('document.edit.sessionCard.dragToReorder' | translate), position: 'top' }"
                                    (click)="$event.stopPropagation()">
                                    <ra-icon icon="menu" varColor="currentColor" [size]="16" />
                                </div>
                            }

                            <!-- Opções -->
                            @if (!disabled()) {
                                <ra-icon
                                    class="session-item-trash"
                                    icon="more"
                                    varColor="currentColor"
                                    [size]="18"
                                    [class.default-disabled]="editService.loading()"
                                    [raEditTooltip]="{ text: ('document.edit.sessionCard.sessionOptions' | translate), position: 'top' }"
                                    (click)="$event.stopPropagation(); isHiddenOptions.set(!isHiddenOptions())" />
                            }
                        </div>
                    }
                </div>
            </div>

            <!-- Sumário da seção ativa: títulos/subtítulos navegam direto ao bloco -->
            @if (sectionOutline().length > 0) {
                <div class="section-outline">
                    @for (heading of sectionOutline(); track heading.key) {
                        <button
                            type="button"
                            class="outline-item ra-overflow-ellipsis"
                            [class.subtitle]="heading.type === itemTypes.SUBTITLE"
                            (click)="goToItem(heading._id, heading.lineIndex)">
                            {{ heading.label }}
                        </button>
                    }
                </div>
            }
        </div>
    </div>

    <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="sessionOptionsOrigin"
        [cdkConnectedOverlayOpen]="!isHiddenOptions()"
        [cdkConnectedOverlayPositions]="sessionOptionsPositions"
        [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
        [cdkConnectedOverlayMinWidth]="245"
        (overlayOutsideClick)="onOptionsClickOutside()">
        <section-options
            [section]="section()"
            [isHidden]="false"
            [isChecklistMode]="isChecklistMode()"
            (typoAllTextsIa)="typoAllTextsIa()"
            (changeNameSession)="isEditingName.set(true)"
            (editDescription)="openDescription()"
            (close)="isHiddenOptions.set(true)">
        </section-options>
    </ng-template>
}

<!-- Modal de edição da descrição da seção -->
@if (isEditingDescription()) {
    <ra-modal-edit-text
        [title]="'document.edit.checklist.descriptionModal.title' | translate"
        [placeholder]="'document.edit.checklist.addDescription' | translate"
        [value]="section().description || ''"
        [limitCharacters]="300"
        (close)="isEditingDescription.set(false)"
        (save)="saveDescription($event)" />
}
